module.exports = { id: "shipping", url: "/build/app/img/symbols.svg#shipping", viewBox: "", toString: function() { return this.url; } };